var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useContext, useMemo, useState, } from 'react';
import { LoadingBounce, createTheme, DialogProvider } from '@michelin/acid-components';
import { MuiThemeProvider, CssBaseline } from '@material-ui/core';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { get, noop } from 'lodash';
import qs from 'qs';
import Cookies from 'js-cookie';
import { SnackbarProvider } from 'notistack';
import SessionExpiredPopup from '../components/SessionExpired/SessionExpiredPopup';
import { Login } from '../components/Login/Login';
import { CentralProviderHeader } from '../components/CentralProviderHeader/CentralProviderHeader';
import GrantError from '../errors/NoGrant';
import ErrorUnauthorized from '../errors/ErrorUnauthorized';
import ErrorUserDeactivated from '../errors/ErrorUserDeactivated';
import { AppOffline } from '../errors/AppOffline';
import { MaintenanceBanner } from '../components/MaintenanceBanner/MaintenanceBanner';
import LegalConsent from '../components/LegalConsent/LegalConsent';
import ValidateProfile from '../components/ValidateProfile/validateProfile';
import { ShareTranslatorService } from '../translations/ShareTranslatorService';
import i18n from '../translations/CentralTranslation';
import { getCacheAuth0Result } from '../helpers/secureCache';
import { logger, loggerOk, loggerError } from '../helpers/Log';
import { expiredSession } from '../helpers/expiredSession';
import Oauth from '../providers/Auth0Provider/Auth0Provider';
import { TERMS_ACCEPTED_KEY, } from '../constants/constants';
import { removeCookie, getCookieDomain } from '../helpers/utils';
import { CentralProviderContext } from '../centralProviderContext/CentralProviderContext';
import { initTranslations } from '../translations/initTranslations';
import { getAuthInfoFromLoginToken } from '../helpers/getAuthInfoFromLoginToken';
import { checkAppStatus } from '../request/checkAppStatus';
import { isGuestRoute } from '../helpers/guestHelpers';
import { CentralProviderHeaderGuest } from '../components/CentralProviderHeader/CentralProviderHeaderGuest';
import { Profile } from '../components/Profile/Profile';
import { AuthContext } from '../authContext/AuthContext';
import { CentralProviderErrorTypes } from '../constants/centralProviderErrors';
import { THEMES } from '../types/Theme';
var SESSION_COOKIE_NAME = 'MISP_MSC';
var idCSS = 'devex-css';
var CentralProviderChildren = function (props) {
    var _a = props.redirect, redirect = _a === void 0 ? 'admin' : _a, _b = props.onLogin, onLogin = _b === void 0 ? noop : _b, children = props.children, redirectToPreviousRoute = props.redirectToPreviousRoute, application = props.application, useTranslationDebugger = props.useTranslationDebugger, languages = props.languages, allowGrantLocationSelector = props.allowGrantLocationSelector, onGrantLocationSelection = props.onGrantLocationSelection, showGlobalSearch = props.showGlobalSearch, allowThemeSwitcher = props.allowThemeSwitcher, onThemeChange = props.onThemeChange, allowedGuestRoutes = props.allowedGuestRoutes, disableNotifications = props.disableNotifications, disableTranslationsManager = props.disableTranslationsManager, useMdmId = props.useMdmId, devexDarkThemeCSS = props.devexDarkThemeCSS, devexLightThemeCSS = props.devexLightThemeCSS;
    var _c = __read(useState(false), 2), sessionDataLoaded = _c[0], setSessionDataLoaded = _c[1];
    var _d = __read(useState(false), 2), afterLogin = _d[0], setAfterLogin = _d[1];
    var guestRoute = isGuestRoute(allowedGuestRoutes);
    var _e = useContext(CentralProviderContext), sessionExpired = _e.sessionExpired, currentLanguage = _e.currentLanguage, displayError = _e.displayError, translationsLoaded = _e.translationsLoaded, centralProfile = _e.centralProfile, termsChecked = _e.termsChecked, status = _e.status, currentTheme = _e.currentTheme, updatedLegalDocuments = _e.updatedLegalDocuments, validateProfileFields = _e.validateProfileFields, showLegalConsent = _e.showLegalConsent, scheduledMaintenance = _e.scheduledMaintenance, setApplication = _e.setApplication, setAllowedLanguages = _e.setAllowedLanguages, setAllowGrantLocationSelector = _e.setAllowGrantLocationSelector, setUseMdmId = _e.setUseMdmId, setShowGlobalSearch = _e.setShowGlobalSearch, setAllowThemeSwitcher = _e.setAllowThemeSwitcher, setDisableNotifications = _e.setDisableNotifications, setDisableTranslationsManager = _e.setDisableTranslationsManager, setAppStatus = _e.setAppStatus, setOnGrantLocationSelection = _e.setOnGrantLocationSelection, setOnThemeChange = _e.setOnThemeChange;
    var _f = useContext(AuthContext), authResult = _f.authResult, setAuthResult = _f.setAuthResult;
    var initTranslationsInternal = function (accessToken) {
        if (disableTranslationsManager)
            return;
        initTranslations({
            accessToken: accessToken,
            useTranslationDebugger: useTranslationDebugger,
            translationsLoaded: translationsLoaded,
            currentLanguage: currentLanguage,
            application: application,
        });
    };
    var checkStatus = function () { return checkAppStatus(application).then(function (response) { return setAppStatus(response, application); }); };
    var setAuthInformation = function (authInfo, fromCache) {
        if (fromCache === void 0) { fromCache = false; }
        setAuthResult(authInfo, fromCache);
        initTranslationsInternal(authInfo.accessToken);
        setSessionDataLoaded(true);
    };
    useEffect(function () {
        logger("mount central provider: ".concat(window.location.origin));
        var location = window.location;
        checkStatus().then(function (appStatus) {
            if (appStatus) {
                if (!location.hash.includes('error=login_required')
                    && !location.hash.includes('error=consent_required')
                    && !location.hash.includes('error=unauthorized')
                    && location.hash.includes('error=')) {
                    // If Auth0 callback includes an unrecognized error, redirect to login
                    Oauth.fullAuthorize();
                }
                setApplication(application);
                setAllowedLanguages(languages);
                if (!guestRoute) {
                    setAllowGrantLocationSelector(allowGrantLocationSelector);
                    setUseMdmId(useMdmId || false);
                    setShowGlobalSearch(showGlobalSearch || false);
                    setAllowThemeSwitcher(allowThemeSwitcher || false);
                    setDisableNotifications(disableNotifications || false);
                    setDisableTranslationsManager(disableTranslationsManager || false);
                    setOnGrantLocationSelection(onGrantLocationSelection);
                    setOnThemeChange(onThemeChange);
                    if (!Cookies.get(SESSION_COOKIE_NAME)) {
                        Cookies.set(SESSION_COOKIE_NAME, 'true', {
                            domain: getCookieDomain(),
                        });
                        if (!document.referrer.includes('launch-pad.oncall')) {
                            sessionStorage.setItem('redirect!', "".concat(window.location.pathname.replace(/^\/+/g, '')).concat(window.location.hash || ''));
                        }
                    }
                    // Checking page param to redirect (added to a new ST key (forceRedirect) to force redirection in case onLogin function is not defined)
                    var urlObj = new URL(window.location.href);
                    var pageToRedirect = urlObj.searchParams.get('page');
                    if (pageToRedirect) {
                        sessionStorage.setItem('forceRedirect', "/".concat(pageToRedirect));
                        urlObj.searchParams.delete('page');
                        // Updating the URL without reloading
                        window.history.replaceState({}, document.title, urlObj.toString());
                    }
                    var authResultCached = getCacheAuth0Result();
                    if (authResultCached) {
                        logger('Getting authResult from cache');
                        setAuthInformation(authResultCached, true);
                    }
                    else {
                        var parsed = qs.parse(window.location.hash.replace('#', ''), {
                            ignoreQueryPrefix: true,
                        });
                        if (parsed.access_token) {
                            localStorage.clear();
                            // After login
                            setAfterLogin(true);
                            var authInfo = getAuthInfoFromLoginToken(parsed);
                            setAuthInformation(authInfo);
                            initTranslationsInternal(parsed.access_token);
                            setSessionDataLoaded(true);
                        }
                        else {
                            // Checking if the current session has expired
                            if (expiredSession()) {
                                Oauth.logout();
                                setSessionDataLoaded(true);
                                return;
                            }
                            // Checking if the user is already logged to avoid redirect to auth0
                            Oauth.checkSession()
                                .then(function (authInfo) { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    loggerOk('success sessionAuth result', authInfo);
                                    loggerOk('JWT-Auth', "".concat(authInfo.idToken));
                                    setAuthInformation(authInfo);
                                    return [2 /*return*/];
                                });
                            }); })
                                .catch(function (e) {
                                loggerError('error getting sessionAuth result', e);
                                removeCookie(TERMS_ACCEPTED_KEY);
                                // Login required
                                setSessionDataLoaded(true);
                            });
                        }
                    }
                }
            }
        });
    }, []);
    useEffect(function () {
        (document.getElementById(idCSS) || {}).href = currentTheme === THEMES.light ? devexLightThemeCSS : devexDarkThemeCSS;
    }, [currentTheme]);
    var renderError = function () {
        var key = get(displayError, 'key') || '';
        var errorProps = get(displayError, 'props') || {};
        switch (key) {
            case CentralProviderErrorTypes.NO_GRANT:
                return React.createElement(GrantError, __assign({}, errorProps));
            case CentralProviderErrorTypes.CALLBACK_ERROR_UNAUTHORIZED:
                return React.createElement(ErrorUnauthorized, __assign({}, errorProps));
            case CentralProviderErrorTypes.USER_DEACTIVATED:
                return React.createElement(ErrorUserDeactivated, __assign({}, errorProps));
            case CentralProviderErrorTypes.APP_OFFLINE:
                return React.createElement(AppOffline, __assign({}, errorProps));
            default:
                return '';
        }
    };
    var accessToken = useMemo(function () { return !!(authResult === null || authResult === void 0 ? void 0 : authResult.accessToken); }, [authResult]);
    return useMemo(function () { return (React.createElement(MuiThemeProvider, { theme: createTheme({ palette: { type: currentTheme } }) },
        React.createElement(CssBaseline, null),
        React.createElement(SnackbarProvider, null,
            React.createElement(React.Fragment, null, guestRoute ? (React.createElement(React.Fragment, null,
                React.createElement(Router, { history: createBrowserHistory() },
                    React.createElement(CentralProviderHeaderGuest, { logoType: currentTheme === THEMES.michelinLightBC ? 'michelin' : 'poweredByMichelin' })),
                React.createElement(CssBaseline, null),
                children)) : (React.createElement(React.Fragment, null,
                sessionExpired && React.createElement(SessionExpiredPopup, null),
                !sessionExpired && (React.createElement(React.Fragment, null,
                    sessionDataLoaded && !displayError && !accessToken && (React.createElement(Login, { redirectToPreviousRoute: redirectToPreviousRoute })),
                    sessionDataLoaded && accessToken && !centralProfile && (React.createElement(Profile, __assign({ redirect: redirect !== null && redirect !== void 0 ? redirect : '', redirectToPreviousRoute: redirectToPreviousRoute }, (afterLogin && { onLogin: onLogin })))),
                    (!sessionDataLoaded
                        || !termsChecked
                        || (accessToken && centralProfile && !translationsLoaded))
                        && status !== false
                        && !displayError && (React.createElement("div", { style: {
                            width: '100%',
                            height: '100%',
                            flex: 1,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        } },
                        React.createElement(LoadingBounce, { style: { height: '100vh' } }))),
                    displayError && (React.createElement(React.Fragment, null,
                        React.createElement(Router, { history: createBrowserHistory() },
                            React.createElement(CentralProviderHeader, { logoType: currentTheme === THEMES.michelinLightBC ? 'michelin' : 'poweredByMichelin' })),
                        React.createElement(CssBaseline, null),
                        renderError())),
                    sessionDataLoaded
                        && status
                        && termsChecked
                        && !displayError
                        && centralProfile
                        && translationsLoaded
                        && accessToken && (React.createElement(React.Fragment, null,
                        showLegalConsent ? (React.createElement(DialogProvider, null,
                            React.createElement(LegalConsent, { updatedDocuments: updatedLegalDocuments }))) : validateProfileFields ? (React.createElement(ValidateProfile, null)) : (React.createElement(React.Fragment, null,
                            scheduledMaintenance
                                && scheduledMaintenance.value && (React.createElement(MaintenanceBanner, { message: i18n.language === 'en_US'
                                    ? scheduledMaintenance.messageEn
                                    : scheduledMaintenance.messageFr, applicationName: scheduledMaintenance.appName, application: application, severity: scheduledMaintenance.severity, visibility: scheduledMaintenance.visibility })),
                            children)),
                        React.createElement(ShareTranslatorService, null))))))))))); }, [
        currentTheme,
        accessToken,
        guestRoute,
        sessionExpired,
        sessionDataLoaded,
        displayError,
        redirectToPreviousRoute,
        centralProfile,
        redirect,
        onLogin,
        termsChecked,
        translationsLoaded,
        status,
        showLegalConsent,
        updatedLegalDocuments,
        validateProfileFields,
        scheduledMaintenance,
        application,
        children,
    ]);
};
export default CentralProviderChildren;
//# sourceMappingURL=CentralProviderChildren.js.map